import { formatNumber, formatDate } from './format';

type T = (key: string, opts?: Record<string, unknown>) => string;

/**
 * EQ-014: the text of the "locked" tag of a bank row/log. When only part of the row is beyond the balance
 * (server-computed `lockedMinutes` < `totalMinutes`) it says "X h of Y locked"; otherwise the whole-row wording.
 * The frontend never works the locked part out itself.
 */
export function bankLockedLabel(t: T, lockedMinutes?: number | null, totalMinutes?: number | null): string {
  const locked = Number(lockedMinutes ?? 0);
  const total = Number(totalMinutes ?? 0);
  if (locked > 0 && total > locked) {
    return t('workLogs.bankLockedPartial', { locked: formatNumber(locked / 60, 2), total: formatNumber(total / 60, 2) });
  }
  return t('workLogs.bankLockedPending');
}

/** EQ-014: the customer-page bank cell - same figures as the bank page: the available balance, plus the locked hours. */
export function bankCellFigures(snap: { balance: number; available_balance?: number | null; over_quota?: { hours?: number | null } | null }) {
  return {
    balance: Number(snap.available_balance ?? snap.balance ?? 0),
    lockedHours: Number(snap.over_quota?.hours ?? 0),
  };
}

/** D-287: the small explanation next to the tag - "the overrun was created in the entry from <date>"; null when no entry is marked. */
export function bankLockedOriginNote(t: T, originDate?: string | null): string | null {
  if (!originDate) return null;
  return t('workLogs.bankLockedOrigin', { date: formatDate(originDate) });
}
